module.exports = __webpack_public_path__ + "static/img/LOGO.f0aae29d.svg";